import { P as PubSub } from './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';

class ProductCode extends HTMLElement {
  #unsubscribers = [];

  connectedCallback() {
    this.#unsubscribers.push(
      PubSub.subscribe('variant:change', ({ data: { html } }) => {
        const productCode = html.querySelector('product-code');
        this.replaceWith(productCode);
      })
    );
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
  }
}

customElements.define('product-code', ProductCode);
